<template>
    <svg class="loading-svg" viewBox="0 0 720 240" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
        <defs>
            <clipPath :id="clipPinkId">
                <circle cx="360" cy="120" r="70">
                    <animate v-bind="animateProps" :values="pinkValues" />
                </circle>
            </clipPath>
            <clipPath :id="clipTealId"><circle cx="360" cy="120" r="70"></circle></clipPath>
            <clipPath :id="clipCreamId">
                <circle cx="360" cy="120" r="70">
                    <animate v-bind="animateProps" :values="creamValues" />
                </circle>
            </clipPath>
        </defs>
        <circle cx="360" cy="120" r="70" fill="#f4298f">
            <animate v-bind="animateProps" :values="pinkValues" />
        </circle>
        <circle cx="360" cy="120" r="70" fill="#80dada"></circle>
        <circle cx="360" cy="120" r="70" fill="#ffe7b7">
            <animate v-bind="animateProps" :values="creamValues" />
        </circle>
        <g :clip-path="`url(#${clipPinkId})`">
            <g :clip-path="`url(#${clipTealId})`">
                <rect x="-400" y="0" width="1600" height="240" fill="#ffbc7a"></rect>
            </g>
        </g>
        <g :clip-path="`url(#${clipTealId})`">
            <g :clip-path="`url(#${clipCreamId})`">
                <rect x="-400" y="0" width="1600" height="240" fill="#a1a5fd"></rect>
            </g>
        </g>
        <g :clip-path="`url(#${clipPinkId})`">
            <g :clip-path="`url(#${clipTealId})`">
                <g :clip-path="`url(#${clipCreamId})`">
                    <rect x="-400" y="0" width="1600" height="240" fill="#BEFEB7"></rect>
                </g>
            </g>
        </g>
    </svg>
</template>

<script setup lang="ts">
import { useId } from "vue";

const baseId = useId();
const clipPinkId = `${baseId}-clip-pink`;
const clipTealId = `${baseId}-clip-teal`;
const clipCreamId = `${baseId}-clip-cream`;

const animateProps = {
    attributeName: "cx",
    dur: "2s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.75;1",
    keySplines: "0 0 .58 1;.42 0 .58 1;.42 0 1 1",
};

const pinkValues = "360;550;170;360";
const creamValues = "360;170;550;360";
</script>
